// A tagged template that escapes every interpolation unless it is already trusted markup.
// No framework: screens are strings, re-rendered on every change.

const TRUSTED = Symbol('trusted');

export interface Trusted {
  [TRUSTED]: true;
  value: string;
}

export function raw(value: string): Trusted {
  return { [TRUSTED]: true, value };
}

const isTrusted = (v: unknown): v is Trusted => typeof v === 'object' && v !== null && TRUSTED in v;

export function esc(s: string): string {
  return s.replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]!);
}

type Part = string | number | boolean | null | undefined | Trusted | Part[];

function emit(v: Part): string {
  if (v === null || v === undefined || v === false || v === true) return '';
  if (Array.isArray(v)) return v.map(emit).join('');
  if (isTrusted(v)) return v.value;
  return esc(String(v));
}

export function html(strings: TemplateStringsArray, ...values: Part[]): Trusted {
  let out = strings[0] ?? '';
  values.forEach((v, i) => {
    out += emit(v) + (strings[i + 1] ?? '');
  });
  return raw(out);
}

export type { Part };
